<template>
  <div class="sidebar-overlay d-md-none" @click="closeSidebar()"></div>
</template>

<script>
export default {
  name: 'sidebar-overlay',
  methods: {
    closeSidebar() {
      this.$store.commit('hideDashSide')
    }
  }
}
</script>
